import React from "react";
import { useLang } from "../context/LanguageContext";
import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { WhyUs } from "../components/home/WhyUs";
import { Testimonials } from "../components/home/Testimonials";
import { useContent } from "../hooks/useContent";
import { CTASection } from "../components/home/FinancialBenefits";

export default function WhyUsPage() {
  const { t } = useLang();
  const { data: testimonials } = useContent("testimonials");
  return (
    <>
      <SEO pageKey="why-us" title={t.seo.why.title} description={t.seo.why.description} />
      <PageHeader pageKey="why-us"
        overline={t.why.overline}
        title={t.why.title}
        image="https://images.unsplash.com/photo-1533105079780-92b9be482077?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />
      <WhyUs />
      <Testimonials testimonials={testimonials} />
      <CTASection />
    </>
  );
}
